import PropTypes from 'prop-types'
import FormRepeater from "../../../../../../../common/FormReapeater.jsx"
import {Card, Col, Row} from "react-bootstrap";
import ButtonWithIcon from "../../../../../../../common/ButtonWithIcon.jsx";
import {Trash} from "react-bootstrap-icons";
import TextareaWiz from "../../../../../../../common/inputs/wizard/TextareaWiz.jsx";
import DateTimeWiz from "../../../../../../../common/inputs/wizard/DateTimeWiz.jsx";
import {HeaderTitle} from "../../../../../../../common/HeaderTitle.jsx";

export const KamienieMiloweRepeater = (props) => {
    const parent = props.parentListName || 'kamienie_list'
    const sortedKamienieMilowe = [...(props.wiz.form?.[parent] || [])].sort((firstItem, secondItem) => {
        if (!firstItem?.kamien_data_osiagniecia && !secondItem?.kamien_data_osiagniecia) return 0
        if (!firstItem?.kamien_data_osiagniecia) return 1
        if (!secondItem?.kamien_data_osiagniecia) return -1

        return new Date(firstItem.kamien_data_osiagniecia).getTime() - new Date(secondItem.kamien_data_osiagniecia).getTime()
    })
    return (
        <FormRepeater
            value={sortedKamienieMilowe}
            onChange={(list) => props.wiz.setValue(parent, list)}
            addButtonText="Dodaj kamień milowy"
            hideNativeDelete
            form={(row, setRow, idx, remove) => (
                <Card className={'d-flex flex-column gap-2 mb-3 w-100'} key={idx}>
                    <Card.Header className={'d-flex justify-content-between align-items-center'}>
                        <HeaderTitle noHr size={'fs-6'} title={`Kamień milowy ${idx + 1}`} />
                        <ButtonWithIcon
                            text={`Usuń kamień ${idx+1}`}
                            onClick={() => remove(idx)}
                            icon={<Trash/>}
                            variant={'danger'}
                        />
                    </Card.Header>
                    <Card.Body className={'p-3'}>
                        <Row>
                            <Col xs={12} sm={9}>
                                <TextareaWiz
                                    wiz={props.wiz}
                                    id={`${parent}.${idx}.kamien_nazwa`}
                                    keyName={`${parent}.${idx}.kamien_nazwa`}
                                    row={row}
                                    setRow={setRow}
                                    idx={idx}
                                    label={`J.1.${idx+1}.1 Nazwa kamienia milowego`}
                                />
                            </Col>

                            <Col xs={12} sm={3}>
                                <DateTimeWiz
                                    hideTime
                                    wiz={props.wiz}
                                    keyName={`${parent}.${idx}.kamien_data_osiagniecia`}
                                    row={row}
                                    setRow={setRow}
                                    idx={idx}
                                    hideLabel
                                    label={`J.1.${idx+1}.2 Data osiągnięcia kamienia milowego`}
                                />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            )}
        />
    )
}

KamienieMiloweRepeater.propTypes = {
    wiz: PropTypes.any.isRequired,
    parentListName: PropTypes.string,
}
export default KamienieMiloweRepeater
